<template>
  <div id="app"> 
    <router-view/>
  </div>
</template>

<script>
export default {
    name: "App",
    created() {
      //console.log('pppppppppppp')
    },
};
</script>

<style> 

.el-table-column--selection .cell{
padding-left:10px !important;
padding-right:10px !important;
}
input::-webkit-input-placeholder {
    color: #c0c4cc !important;
  }
  input::-moz-input-placeholder {
    color: #c0c4cc !important;
  }
  input::-ms-input-placeholder {
    color: #c0c4cc !important;
  }
 .content_box >>> .el-table .DisabledSelection .cell .el-checkbox__inner{
    /* margin-left: -30px; */
    position:relative;
  }
.content_box >>>.el-table__header-wrapper .el-checkbox__input::after {
    content: '全选';
    position: absolute;
    margin-left: 10px;
    font-weight: bold;
}
html,
body {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0px;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    widows: 100%;
    height: 100%;
}
.content_box_title {
  display: flex;
  align-items: center;
}
.circle_l {
  width: 18px;
  height: 18px;
  background: #5178ff;
  border-radius: 50%;
}
.circle_r {
  width: 18px;
  height: 18px;
  background: rgba(81, 120, 255, 0.27);
  border-radius: 50%;
  margin-left: -7px;
}
.text_xl {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  margin-left: 20px;
  color: #333333;
}
.el-tabs__nav-wrap::after{
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue